<template>
  <IconLucideFlag />
</template>
